/**!
 * Copyright 2016 xdot GmbH
 *
 * Author: Carsten Hibbeler
 * Date: 13.10.2016
 *
 */
import L from 'external/leaflet';

export default () => {
    if (L.drawLocal && L.drawLocal.isTranslated) {
        return;
    }

    L.drawLocal = {
        ...L.drawLocal, ...{
            isTranslated: true,
            draw: {
                toolbar: {
                    actions: {
                        title: 'Zeichnen abbrechen',
                        text: 'Abbrechen'
                    },
                    finish: {
                        title: 'Zeichnen abschließen',
                        text: 'Abschließen'
                    },
                    undo: {
                        title: 'Letzten gezeichneten Punkt löschen',
                        text: 'Letzten Punkt löschen'
                    },
                    buttons: {
                        polyline: 'Polylinie zeichnen',
                        polygon: 'Polygon zeichnen',
                        rectangle: 'Rechteck zeichnen',
                        circle: 'Kreis zeichnen',
                        marker: 'Marker zeichnen',
                        circlemarker: 'Kreismarker zeichnen'
                    }
                },
                handlers: {
                    circle: {
                        tooltip: {
                            start: 'Klicken und ziehen, um einen Kreis zu zeichnen.'
                        },
                        radius: 'Radius'
                    },
                    circlemarker: {
                        tooltip: {
                            start: 'Klicken, um einen Kreismarker zu zeichnen.'
                        }
                    },
                    marker: {
                        tooltip: {
                            start: 'Auf die Karte klicken, um einen Marker zu zeichnen.'
                        }
                    },
                    polygon: {
                        tooltip: {
                            start: 'Klicken zum Zeichnen eines Polygons.',
                            cont: 'Klicken zum Zeichnen eines Polygons.',
                            end: 'Auf ersten Punkt klicken, um Polygon abzuschließen.'
                        }
                    },
                    polyline: {
                        error: '<strong>Fehler:</strong> Kanten dürfen sich nicht überschneiden!',
                        tooltip: {
                            start: 'Klicken zum Zeichnen einer Polylinie.',
                            cont: 'Klicken zum Zeichnen einer Polylinie.',
                            end: 'Auf letzten Punkt klicken, um Polylinie abzuschließen.'
                        }
                    },
                    rectangle: {
                        tooltip: {
                            start: 'Klicken und ziehen, um ein Rechteck zu zeichnen.'
                        }
                    },
                    simpleshape: {
                        tooltip: {
                            end: 'Maus loslassen, um Zeichnen zu beenden.'
                        }
                    }
                }
            },
            edit: {
                toolbar: {
                    actions: {
                        save: {
                            title: 'Änderungen speichern.',
                            text: 'Speichern'
                        },
                        cancel: {
                            title: 'Zeichnen abbrechen und alle Änderungen verwerfen.',
                            text: 'Abbrechen'
                        },
                        clearAll: {
                            title: 'Alle Zeichnungen löschen.',
                            text: 'Alle löschen'
                        }
                    },
                    buttons: {
                        edit: 'Layer bearbeiten.',
                        editDisabled: 'Keine Layer zum Bearbeiten.',
                        remove: 'Layer löschen.',
                        removeDisabled: 'Keine Layer zum Löschen.'
                    }
                },
                handlers: {
                    edit: {
                        tooltip: {
                            text: 'Zum Editieren, Layer verschieben.',
                            subtext: 'Auf Abbrechen klicken, um Änderungen rückgängig zu machen.'
                        }
                    },
                    remove: {
                        tooltip: {
                            text: 'Zum Löschen auf einen Layer klicken.'
                        }
                    }
                }
            }
        }
    };
};



// WEBPACK FOOTER //
// ./js/plugins/DrawerPlugin/translate-leaflet-drawer.js